import Main from 'routes/Main/containers/MainContainer';

export default Main;
